<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col>
                    <div>
                        <p class="font-weight-bold">SECTION B: PROGRAM INFORMATION</p>
                    </div>
                    <div>
                        <p>The following information reflects your specific Continuing Education cohort placement.</p>
                    </div>
                    <b-table-simple
                        responsive
                        striped
                        hover
                        class="text-sm text-md-md"
                    >
                        <b-thead>
                            <b-tr></b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr
                                v-for="(menu, j) in data"
                                :key="j"
                                class="py-2 py-md-3"
                            >
                                <b-td class="font-weight-bold">{{ menu.key }}</b-td>
                                <b-td>
                                    <span v-html="menu.value"></span>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider
                                name="status"
                                rules="required"
                                v-slot="{ valid, errors }"
                            >
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-ce-b"
                                        v-model="form.status"
                                        name="checkbox-ce-b"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    >
                                    </b-form-checkbox>
                                    <p>
                                        I read and confirm that I understand the information in Section B.
                                    </p>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto"
                            >
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
    data() {
        return {
            form: {},
            data: []
        }
    },
    created() {
        this.getData()
    },
    computed: {
        ...mapGetters({
            formData: "enrollmentAgreementForm/formData"
        })
    },
    methods: {
        async getData() {
            window.scrollTo(0, 0)
            const data = this.formData;
            this.data.push(
                {
                    key: 'Program of Study',
                    value: 'Continuing Education Certificate',
                },
                {
                    key: 'Program Structure',
                    value: 'Non-credit professional certification journey',
                },
                {
                    key: 'Instructional Modality',
                    value: data.registration_type_text ? data.registration_type_text : '–',
                },
                {
                    key: 'Program Duration / Timeline',
                    value: data.active_module_start_date
                        ? `${data.active_module_start_date} – ${data.active_module_end_date}`
                        : (data.registration_term ? `${data.registration_term} term schedule.` : '–'),
                },
                {
                    key: 'Total Credits Required for Graduation',
                    value: '0 Credits (This is a non-credit program; completion is verified via 80% attendance criteria).',
                },
            )

            await this.$store.dispatch('enrollmentAgreementForm/deleteFormData');
            await this.$store.dispatch('enrollmentAgreementForm/saveFormData', data);
        },
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.$emit('next', 1)
            }
        },
        back() {
            this.$emit('back', -1);
        }
    }
}
</script>
